export const routesConfig = [
  {
    name: 'Profile',
    translation: 'profile'
  },
  {
    name: 'PickupBoxes',
    translation: 'pickupBoxes'
  },
  {
    name: 'Sensors',
    translation: 'sensors'
  },
  {
    name: 'Users',
    translation: 'users'
  },
  {
    name: 'CustomersFeedback',
    translation: 'customersFeedback'
  }
];
